/**
 * Environment detection utility
 * Determines if the app is running in development or production
 */

export const isDevelopment = () => {
  // Check multiple indicators for development environment
  const checks = [
    // Standard React environment variable
    process.env.NODE_ENV === "development",

    // Custom environment variable (if set)
    process.env.REACT_APP_ENV === "development",

    // Local development hostnames
    window.location.hostname === "localhost",
    window.location.hostname === "127.0.0.1",
    window.location.hostname === "0.0.0.0",

    // Common development ports
    window.location.port === "3000",
    window.location.port === "3001",
    window.location.port === "8080",

    // Development domain patterns
    window.location.hostname.includes("localhost"),
    window.location.hostname.includes("dev."),
    window.location.hostname.includes("staging."),
    window.location.hostname.includes("test."),

    // Netlify/Vercel preview deployments
    window.location.hostname.includes("deploy-preview"),
    window.location.hostname.includes("branch-deploy"),
    window.location.hostname.includes("vercel.app") &&
      !window.location.hostname.includes("production"),

    // Check for development query parameter (manual override)
    new URLSearchParams(window.location.search).get("dev") === "true",

    // Secret debug parameter for production debugging
    new URLSearchParams(window.location.search).get("debug") === "plum2024",
  ];

  // Return true if any development indicator is found
  return checks.some(check => check === true);
};

export const isProduction = () => {
  return !isDevelopment();
};

export const getEnvironment = () => {
  return isDevelopment() ? "development" : "production";
};

/**
 * Console log wrapper that only outputs in development
 */
export const devLog = (...args) => {
  if (isDevelopment()) {
    console.log(...args);
  }
};

/**
 * Console warn wrapper that only outputs in development
 */
export const devWarn = (...args) => {
  if (isDevelopment()) {
    console.warn(...args);
  }
};

/**
 * Console error wrapper that only outputs in development
 */
export const devError = (...args) => {
  if (isDevelopment()) {
    console.error(...args);
  }
};

/**
 * Check if debug mode is enabled in production
 * Usage: Add ?debug=plum2024 to URL in production to enable performance monitor
 */
export const isDebugMode = () => {
  return (
    new URLSearchParams(window.location.search).get("debug") === "plum2024"
  );
};

/**
 * Check if performance monitoring should be enabled
 * Enabled in development OR when debug mode is active in production
 */
export const shouldShowPerformanceMonitor = () => {
  return isDevelopment() || isDebugMode();
};
